import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { userSettingsStoreStateSelector } from '~/selectors';

export const useUserSettings = <T extends object>(
  resolveUserSettings: (remoteUserSettings: Partial<T> | undefined) => T,
  key: string,
): { personalWorkspaces: T; hasDataPersonalWorkspaces: boolean } => {
  const { userSettings } = useSelector((state: StoreState) => {
    return userSettingsStoreStateSelector(state);
  });

  return useMemo(() => {
    const selectorState = userSettings[key];

    const data = resolveUserSettings(selectorState?.data);

    return {
      personalWorkspaces: data,
      hasDataPersonalWorkspaces: !selectorState?.hasData,
    };
  }, [userSettings, resolveUserSettings, key]);
};
